import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PerformanceHero from "./sections/PerformanceHero";
import Trustbar from "./sections/Trustbar";
import FeaturedCompounds from "./sections/FeaturedCompounds";
import Edge from "./sections/Edge";
import Purity from "./sections/Purity";
import Research from "./sections/Research";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PerformanceHero />
      <Trustbar />
      <FeaturedCompounds />
      <Edge />
      <Purity />
      <Research />
      <Inquiries />
      <Footer />
    </div>;
}